<template>
    <div :class="isDetails ? 'page_detail page gray_bg' : 'page_list'" class="list_page">
        <div class="page_top" v-show="!isDetails">
            <div class="title" @click="goHome()"><i class="icon"></i>運輸媒合</div>
            <div class="search_type">
                <div class="item" :class="{'is-active': qkSearch}" @click="changeSearchType(true)">快速搜尋</div>
                <div class="item" :class="{'is-active': !qkSearch}" @click="changeSearchType(false)">進階搜尋</div>
            </div>
            <div class="search_bar">
                <template v-if="qkSearch">
                    <div class="qk">
                        <div class="item" :class="qkArea === 'a' ? 'is-active': ''" @click="searchQK('a')">全部</div>
                        <div class="item" :class="qkArea === 'n' ? 'is-active': ''" @click="searchQK('n')">北部</div>
                        <div class="item" :class="qkArea === 'c' ? 'is-active': ''" @click="searchQK('c')">中部</div>
                        <div class="item" :class="qkArea === 's' ? 'is-active': ''" @click="searchQK('s')">南部</div>
                        <div class="item" :class="qkArea === 'e' ? 'is-active': ''" @click="searchQK('e')">東部</div>
                    </div>
                </template>
                <template v-else>
                    <div class="mo">
                        <div class="item" :class="subSelect === 'type' ? 'is-active': ''" @click="changeSelect('type')">
                            分類
                        </div>
                        <div class="item" :class="subSelect === 'area' ? 'is-active': ''" @click="changeSelect('area')">
                            地區
                        </div>
                        <div class="item" :class="subSelect === 'pay' ? 'is-active': ''" @click="changeSelect('car')">
                            車輛
                        </div>
                        <div class="item" :class="subSelect === 'pay' ? 'is-active': ''" @click="changeSelect('time')">
                            時間
                        </div>
                    </div>
                    <div class="mo_select" v-if="subSelect">
                        <template v-if="subSelect === 'type'">
                            <div class="tit">分類</div>
                            <el-select class="select_area" popper-class="select_area_popper" v-model="form.caseType"
                                       @change="handleSearch">
                                <el-option label="全部" value=""></el-option>
                                <el-option v-for="({id, name},idx) in caseType" :label="name" :value="id" :key="idx"/>
                            </el-select>
                        </template>
                        <template v-if="subSelect === 'area'">
                            <div class="tit">選擇地區</div>
                            <div class="select_flex">
                                <div class="item">
                                    <!-- <div class="tit">從</div> -->
                                    <div class="select_clear">
                                        <i class="el-icon-error icon" v-if="form.areaFrom.length"
                                           @click="form.areaFrom = []"></i>
                                        <el-select class="select_area" popper-class="select_area_popper" multiple
                                                   clearable v-model="form.areaFrom" placeholder="請選擇">
                                            <el-option v-for="({areaId, areaName},idx) in searchArea" :label="areaName"
                                                       :value="areaId" :key="idx"/>
                                        </el-select>
                                    </div>
                                </div>
                                <div class="item_text">至</div>
                                <div class="item">
                                    <!-- <div class="tit">到</div> -->
                                    <div class="select_clear">
                                        <i class="el-icon-error icon" v-if="form.areaTo.length"
                                           @click="form.areaTo = []"></i>
                                        <el-select class="select_area" popper-class="select_area_popper" multiple
                                                   clearable v-model="form.areaTo" placeholder="請選擇">
                                            <el-option v-for="({areaId, areaName},idx) in searchArea" :label="areaName"
                                                       :value="areaId" :key="idx"/>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div class="btn">
                                <el-button type="success" :disabled="loading" @click="handleSearch()"><i
                                    class="el-icon-loading" v-if="loading"></i>送出
                                </el-button>
                            </div>
                        </template>
                        <template v-if="subSelect === 'car'">
                            <div class="select_clear">
                                <i class="el-icon-error icon" v-if="form.carType.length" @click="form.carType = []"></i>
                                <el-select class="select_area" popper-class="select_area_popper" multiple
                                           v-model="form.carType">
                                    <el-option v-for="({id, name},idx) in carType" :label="name" :value="id"
                                               :key="idx"/>
                                </el-select>
                            </div>
                            <div class="btn">
                                <el-button type="success" :disabled="loading" @click="handleSearch()"><i
                                    class="el-icon-loading" v-if="loading"></i>送出
                                </el-button>
                            </div>
                        </template>
                        <template v-if="subSelect === 'time'">
                            <div class="select_flex">
                                <div class="item select_clear">
                                    <i class="el-icon-error icon" v-if="startDate" @click="startDate = ''"></i>
                                    <!-- <div class="tit">從</div> -->
                                    <el-date-picker
                                        v-model="startDate"
                                        type="date"
                                        placeholder="選擇日期">
                                    </el-date-picker>
                                </div>
                                <div class="item_text">至</div>
                                <div class="item select_clear">
                                    <!-- <div class="tit">到</div> -->
                                    <i class="el-icon-error icon" v-if="endDate" @click="endDate = ''"></i>
                                    <el-date-picker
                                        v-model="endDate"
                                        type="date"
                                        align="right"
                                        placeholder="選擇日期">
                                    </el-date-picker>
                                </div>
                            </div>
                            <div class="btn">
                                <el-button type="success" :disabled="loading" @click="handleSearch()"><i
                                    class="el-icon-loading" v-if="loading"></i>送出
                                </el-button>
                            </div>
                        </template>
                    </div>
                </template>
            </div>
        </div>
        <div class="page_padding" :class="{'page_loading': listLoading}" v-infinite-scroll="scrollLoad"
             infinite-scroll-immediate="false">
            <div class="cate" v-show="!isDetails">
                <!-- <div class="search_type" @click="changeSearchType()">{{qkSearch ? '進階搜尋' : '快速搜尋'}}</div> -->
                <div class="item" :class="searchType === 'all' ? 'is-active': ''" @click="changeTag('all')">運輸媒合</div>
                <div class="item" :class="searchType === 'my' ? 'is-active': ''" @click="changeTag('my')">我的刊登</div>
            </div>
            <template v-if="isDetails">
                <router-view/>
            </template>
            <ul class="list" v-else>
                <template v-if="listLoading">
                    <div class="loading">
                        <i class="el-icon-loading"></i>
                    </div>
                </template>
                <template v-else>
                    <template v-if="(caseList || {}).length > 0">
                        <div
                            v-for="({id, caseTypeId,caseType, carType, startDate, endDate, areaFrom, areaTo, createdAt,updatedAt, title ,isFinish},idx) in pageData"
                            :key="idx">
                            <li class="item box_item" style="position: relative">
                                <div class="box_tag" :class="{find_car:caseTypeId==2}">
                                    <span>{{caseType}}</span>
                                    <span>{{carType}}</span>
                                    <span><i class="el-icon-time"></i>{{getPostDate(updatedAt)}}</span>
                                </div>
                                <div class="box_content" @click="handleDetail(id)">
                                    <el-tag type="danger" effect="dark" style="float: right" v-if="isFinish == 1">
                                        已結束
                                    </el-tag>
                                    <div class="tag">配送時間 </div>
                                    <div class="date">{{getDateMode(startDate,endDate)}} </div>
                                    <div class="point">
                                        <p class="place">{{areaFrom}}<i class="el-icon-right"></i>{{areaTo}}</p>
                                        <!-- <p class="money"><span>NT$</span>面議</p> -->
                                    </div>
                                    <div class="data">{{title}}</div>
                                </div>
                                <div v-if="searchType=='my' && checkArticleRenewDate(updatedAt)"
                                     style="position: absolute;z-index: 999; top: 55px;right: 11px">
                                    <el-button type="warning" @click="renewArticle(id)">更新排序</el-button>
                                </div>

                            </li>

                            <template>
                                <InFeedAdsense
                                    v-if="idx%4==0 && idx!=0"
                                    data-ad-layout-key="-fb+5w+4e-db+86"
                                    data-ad-client="ca-pub-9879330354493543"
                                    data-ad-slot="5365863390">
                                </InFeedAdsense>
                            </template>


                        </div>

                    </template>
                    <template v-else>
                        <template v-if="!pageState">
                            <li class="no_mydata">
                                <p class="txt">連線失敗，請稍後再試</p>
                                <p>
                                    <el-button type="success" :disabled="loading" @click="addPage">重試</el-button>
                                </p>
                            </li>
                        </template>
                        <template v-else>
                            <li v-if="isMyTagData" class="no_mydata">
                                <p class="tit">暫無刊登</p>
                                <p class="txt">目前沒有刊登，請前往刊登</p>
                                <p>
                                    <el-button type="success" :disabled="loading" @click="addPage">我要刊登</el-button>
                                </p>
                            </li>
                            <li v-else class="no_data">目前尚無任何資料</li>
                        </template>
                    </template>
                </template>
            </ul>
        </div>
        <div class="add_btn" @click="addPage" v-if="!isDetails && !isMyTagData"></div>
        <MENU v-if="!isDetails"/>
        <el-backtop target=".list_page .page_padding" v-if="!isDetails" :visibility-height="500" :bottom="150"
                    :right="25"/>
    </div>
</template>
<script>
    import FN from '@/components/fn'
    import {mapActions, mapGetters} from 'vuex'
    import MENU from '@/components/menu.vue'
    import DialogTerms from '@/components/DialogTerms'
    import _ from 'lodash'
    import moment from 'moment/min/moment-with-locales'
    import ArticleService from '@/components/servicies/ArticleService.vue'
    import {next} from "lodash/seq";

    export default {
        name: 'case',
        components: {
            DialogTerms,
            MENU,
        },
        mixins: [FN, ArticleService],
        data() {
            return {
                dialogVisible: false,
                qkSearch: true,
                qkArea: '',
                subSelect: '',
                searchType: 'all',
                pageTag: '',
                pageCount: 1, //實際頁數
                pageNum: 1, //打時計算
                allData: [],
                startDate: '',
                endDate: '',
                apiKey: {
                    'all': 'CASE_LIST',
                    'my': 'CASE_MYLIST'
                },
                form: {
                    carType: [],
                    areaTo: [],
                    areaFrom: [],
                    caseType: '',
                    startDate: '',
                    endDate: '',
                    page: 1,
                    pageLimit: 15
                },
                renewData: {
                    articleId: "",
                    articleType: 1,
                }
            }
        },
        mounted() {
            //取得分類
            this.getSearchType()
            //取得地區
            this.getArea()
            //取得求職徵才列表
            this.handleSearch()

        },
        computed: {
            ...mapGetters([
                'carType',
                'caseType',
                'searchArea',
                'caseList',
                'pages',
                'pageState'
            ]),
            isDetails() {
                const details = this.$route.name !== 'Case'
                return details
            },
            isMyTagData() {
                return this.searchType === 'my' && !this.caseList?.length
            },
            pageData() {
                this.caseList.forEach((item) => {
                    this.allData.push(item)
                })
                return this.allData
            }
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            getSearchType() {
                this.FETCH({
                    key: 'CASE_TYPE'
                })
                this.FETCH({
                    key: 'CAR_TYPE'
                })
            },
            getArea() {
                this.FETCH({
                    key: 'SEARCH_AREA'
                })
            },
            changeSelect(val) {
                if (this.subSelect === val) {
                    this.subSelect = ''
                } else {
                    this.subSelect = val
                }
            },
            changeSearchType(val) {
                this.clearSearchData() //清除進階搜尋資料
                this.qkSearch = val
            },
            searchQK(val) {
                this.clearSearchData() //清除進階搜尋資料
                this.qkArea = val
                const areaList = {
                    'a': [],
                    'n': [2, 3, 4, 5, 6],
                    'c': [7, 8, 9, 10, 11],
                    's': [12, 13, 14, 15],
                    'e': [16, 17, 18]
                }
                this.form.areaFrom = areaList[val]
                this.handleSearch()
            },
            beforeSearch() {
                this.form.startDate = this.startDate ? moment(this.startDate).format('YYYYMMDD') : ''
                this.form.endDate = this.endDate ? moment(this.endDate).format('YYYYMMDD') : ''
                return true
            },
            handleSearch(limit) {
                if (!limit) {
                    this.listLoading = true
                }
                this.subSelect = ''
                this.searchType = this.$route.params.tag
                if (this.beforeSearch()) {
                    this.FETCH({
                        key: this.apiKey[this.searchType],
                        ...this.form,
                        page: limit || this.form.page,
                        pageLimit: this.form.pageLimit
                    })
                        .then((res) => {
                            //需要accToken的驗證
                            if (+(res || {}).code === -3) {
                                this.checkNewToken(this.handleSearch)
                            }
                            if (!+(res || {}).code) {
                                this.pageCount = this.pages?.current_page
                                //如果是第一頁記得要消除暫存區並捲動到最上方
                                if (this.pages?.current_page === 1) {
                                    this.clearListData()
                                }
                                if (+this.pageCount === 1) {
                                    this.moreLoading = false
                                    setTimeout(() => {
                                        this.listLoading = false
                                    }, 1000);
                                } else {
                                    this.listLoading = false
                                    setTimeout(() => {
                                        this.moreLoading = false
                                    }, 1000);
                                }
                            }
                        })
                        .catch(() => {
                            this.pageCount = this.pages?.current_page
                        })
                }
            },
            changeOrderBy(val) {
                this.form.orderByPay = val
                this.handleSearch()
            },
            addPage() {
                // const { href } = this.$router.resolve({name: 'JobAdd'})
                // window.open(href, '_self')
                this.$router.push({name: 'CaseAdd'})
            },
            changeTag(tagVal) {
                this.listLoading = true
                this.clearSearchData() //清除搜尋資料
                this.$router.push({
                    params: {tag: tagVal}
                })
                //this.searchList(tagVal)
                this.handleSearch()
            },
            handleDetail(id) {
                this.$router.push({name: 'CaseDetails', params: {id: id}})
            },
            //滾動加載分頁
            scrollLoad: _.throttle(function () {
                const lastPage = this.pages.last_page
                const nowPage = this.pages.current_page
                if (lastPage > nowPage) {
                    this.moreLoading = true
                    this.pageCount++
                    this.handleSearch(this.pageCount)
                }
            }, 2000),
            //清除搜尋資料
            clearSearchData() {
                this.qkArea = ''
                this.form.carType = []
                this.form.areaTo = []
                this.form.areaFrom = []
                this.form.caseType = ''
                this.form.startDate = ''
                this.form.endDate = ''
                this.startDate = ''
                this.endDate = ''
            },
            //清除資料
            clearListData() {
                document.querySelector(".list_page .page_padding").scrollTop = 0
                this.allData = []
            },
            getDateMode(start, end) {
                if (start && end) {
                    return `${start} - ${end}`
                }
                if (start) {
                    return `${start} 起`
                }
                if (end) {
                    return `至 ${end}`
                }
                return '不限時間'
            },
        },
        beforeUpdate() {
            localStorage.setItem('caseDateTime', moment().format('YYYY-MM-DD HH:mm:ss'));
        },

    }
</script>
